import * as React from 'react';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import * as Api from 'src/api';
import ContentSubtypeForm from 'src/components/ContentSubtype/form';

class ContentSubtypeCreateContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentSubtype: {
        name: ''
      },
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  public async onSubmit(body: any): Promise<void> {
    await Api.createContentSubtype(body);

    toast.success('El registro fue creado con éxito');
    return this.props.history.push('/subtipos-de-contenido');
  }

  public render() {
    return <ContentSubtypeForm contentSubtype={this.state.contentSubtype} onSubmit={this.onSubmit}/>
  }
}

export default withRouter(ContentSubtypeCreateContainer);



// WEBPACK FOOTER //
// ./src/containers/ContentSubtype/create.tsx